import { render } from "./PersonDetailCard.vue?vue&type=template&id=778ccedc&scoped=true&ts=true"
import script from "./PersonDetailCard.vue?vue&type=script&lang=ts"
export * from "./PersonDetailCard.vue?vue&type=script&lang=ts"

import "./PersonDetailCard.vue?vue&type=style&index=0&id=778ccedc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778ccedc"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QToolbar,QBtn,QToolbarTitle,QTooltip,QCardSection,QLinearProgress});
